module.exports =
  accepted:     [Object]
  deprecated:   "nesting_aggs"
  objectAccess: false
  value:        {}
